import request from '@/providers/http-service'
import qs from 'qs'
const url = '/tbase-iam-manage'
// 查询字典类型列表
export function DictionaryTypeList(params) { //
  return request({
    url: url + '/dict/type/root',
    method: 'post',
    data: params
  })
}
// 查询字典条目列表
export function DictionaryItemList(params) { //
  return request({
    url: url + '/dict/tree',
    method: 'post',
    data: params
  })
}
export function dictItemRoot(params) { //
  return request({
    url: url + '/dict/item/root',
    method: 'post',
    data: params
  })
}
// 获取字典选择框列表
export function dictTypeOption(params) { //
  return request({
    url: url + '/dict/type/option',
    method: 'get',
    data: params
  })
}
// 添加或修改字典类型
export function AddDictionaryType(params) { //
  return request({
    url: url + '/dict/type/saveOrUpdate',
    method: 'post',
    data: params
  })
}
// 删除字典类型
export function DeleteDictionaryType(params) { //
  return request({
    url: url + '/dict/type/delete/',
    method: 'get',
    data: params
  })
}
// 添加或修改条目
export function dictItemAdd(params) { //
  return request({
    url: url + '/dict/item/saveOrUpdate',
    method: 'post',
    data: params
  })
}
// 查询部门下拉列表
export function getDeptArray(params) { //
  return request({
    url: url + '/dept/array',
    method: 'post',
    data: params
  })
}
// 查询部门非树形

export function getDeptQuery(params) { //
  return request({
    url: url + '/dept/query',
    method: 'post',
    data: params
  })
}
// 查询角色下拉列表
export function getRoleArray(params) { //
  return request({
    url: url + '/role/array',
    method: 'post',
    data: params
  })
}
// 查询自己的角色列表
export function getRoleUser(params) { //
  return request({
    url: url + `/role/user/${params.id}`,
    method: 'get',
    params
  })
}
// 分页查询用户列表
export function getUserList(params) { //
  return request({
    url: url + '/user/listOutLinshi',
    method: 'post',
    data: params
  })
}
// 分页查询用户列表
export function getUserList2(params) { //
  return request({
    url: url + '/user/list',
    method: 'post',
    data: params
  })
}
// 用户启用或禁用
export function UserSwitch(params) { //
  return request({
    url: url + '/user/switch',
    method: 'post',
    data: params
  })
}


export function downloadFile(params) { //
  return request({
    url: url + '/file/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

export function getUserDetail(id) { //
  return request({
    url: url + '/user/detail/' + id,
    method: 'get'
  })
}

// 导出用户数据
export function expUserList(params) { //
  return request({
    url: url + '/user/expUserList',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 获取部门资源树形
export function getDeptTree(params) { //
  return request({
    url: url + '/dept/tree',
    method: 'post',
    data: params
  })
}
// 创建或修改用户信息
export function setUserSave(params) { //
  return request({
    url: url + '/user/save',
    method: 'post',
    data: params
  })
}
// 创建或修改用户信息
export function checkStaff(params) { //
  return request({
    url: url + '/user/checkStaff',
    method: 'post',
    data: params
  })
}

// 用户角色绑定
export function setUserRole(params) { //
  return request({
    url: url + '/user/role',
    method: 'post',
    data: params
  })
}
// 根据角色获取应用
export function roleApp(params) { //
  return request({
    url: process.env.VUE_APP_API_DOMAIN + '/tbase-iam-manage/plate/app-role-middle/roleApp',
    method: 'post',
    data: params
  })
}
// 根据角色获取应用
export function bindApp(params) { //
  return request({
    url: process.env.VUE_APP_API_DOMAIN + '/tbase-iam-manage/plate/app-role-middle/bind',
    method: 'post',
    data: params
  })
}
// 分页查询角色列表
export function getRoleList(params) { //
  return request({
    url: url + '/role/tree',
    method: 'post',
    data: params
  })
}
export function getRoleRoot(params) { //
  return request({
    url: url + '/role/root',
    method: 'post',
    data: params
  })
}
// 创建或修改角色信息
export function setRoleSave(params) { //
  return request({
    url: url + '/role/save',
    method: 'post',
    data: params
  })
}

// 获取角色权限树形
export function setMenuTree(params) { //
  return request({
    url: url + '/menu/tree',
    method: 'post',
    data: params
  })
}
// 权限分配
export function setRoleGrant(params) { //
  return request({
    url: url + '/role/grant',
    method: 'post',
    data: params
  })
}
// 查询菜单列表
export function getMenuList(params) { //
  return request({
    url: url + '/menu/tree',
    method: 'post',
    data: params
  })
}
export function getMenuRoot(params) { //
  return request({
    url: url + '/menu/root',
    method: 'post',
    data: params
  })
}
export function getDeptTreet(params) { //
  return request({
    url: url + '/dept/tree',
    method: 'post',
    data: params
  })
}
export function getDeptRoot(params) { //
  return request({
    url: url + '/dept/root',
    method: 'post',
    data: params
  })
}
// 创建或修改部门信息
export function setDeptSave(params) { //
  return request({
    url: url + '/dept/save',
    method: 'post',
    data: params
  })
}
// 查询当前部门用户
export function getDeptUser(params) { //
  return request({
    url: url + '/dept/user',
    method: 'post',
    data: params
  })
}
// 查找不在当前部門的用户
export function getDeptOtherUser(params) { //
  return request({
    url: url + '/dept/other/user',
    method: 'post',
    data: params
  })
}
// 部门添加用户
export function getDeptAddUser(params) { //
  return request({
    url: url + '/dept/add/user',
    method: 'post',
    data: params
  })
}
// 部门去除用户
export function getDeptDeleteUser(params) { //
  return request({
    url: url + '/dept/delete/user',
    method: 'post',
    data: params
  })
}
// 部门角色绑定
export function setDdeptRole(params) { //
  return request({
    url: url + '/dept/role',
    method: 'post',
    data: params
  })
}
// 创建或修改菜单信息
export function setMenuSave(params) { //
  return request({
    url: url + '/menu/save',
    method: 'post',
    data: params
  })
}
// 启用或停用
export function setMenuSwitch(params) { //
  return request({
    url: url + '/menu/switch',
    method: 'post',
    data: params
  })
}
// 查找当前菜单的资源
export function getMenuResource(params) { //
  return request({
    url: url + '/menu/resource',
    method: 'post',
    data: params
  })
}
// 创建或修改菜单资源
export function setMenuSaveResource(params) { //
  return request({
    url: url + '/menu/save/resource',
    method: 'post',
    data: params
  })
}
// 菜单去除资源
export function setMenuDeleteResource(params) { //
  return request({
    url: url + '/menu/delete/resource',
    method: 'post',
    data: params
  })
}
// 用户类型
export function userType(params) { //
  return request({
    url: url + '/dict/item/list',
    method: 'post',
    data: params
  })
}
// 查询应用下拉列表
export function getAppArray(params) { //
  return request({
    url: url + '/app/array',
    method: 'post',
    data: params
  })
}

// 用户修改密码
export function setUserPassword(params) { //
  return request({
    url: url + '/user/password',
    method: 'post',
    data: params
  })
}
// 批量刪除字典
export function setItemBatchDelete(params) { //
  return request({
    url: url + '/dict/item/batchDelete',
    method: 'post',
    data: params
  })
}
export function setDictTypeBatchDelete(params) { //
  return request({
    url: url + '/dict/type/batchDelete',
    method: 'post',
    data: params
  })
}
// 用户恢复，状态置为1,仅删除状态可恢复
export function setUserReset(params) { //
  return request({
    url: url + '/user/reset',
    method: 'post',
    data: params
  })
}
// 系统消息列表查询
export function getSysMsgList(params) { //
  return request({
    url: url + '/sys/msg/list',
    method: 'post',
    data: params
  })
}
// 模板消息列表
export function getMsgTemplateList(params) { //
  return request({
    url: url + '/msg/template/list',
    method: 'post',
    data: params
  })
}
// 新增或修改模板
export function setMsgTemplateAdd(params) { //
  return request({
    url: url + '/msg/template/add',
    method: 'post',
    data: params
  })
}
// 编辑模板
export function setMsgTemplateEdit(params) { //
  return request({
    url: url + '/msg/template/edit',
    method: 'post',
    data: params
  })
}
// 发送消息
export function setMsgTemplateSendMsg(params) { //
  return request({
    url: url + '/msg/template/sendMsg',
    method: 'post',
    data: params
  })
}
// 发送消息
export function verificationCodeApi(params) { //
  return request({
    url: url + '/sys/msg/verificationCode',
    method: 'get',
    params
  })
}


// 流转记录
export function taskDetail(params) { //
  return request({
    url: process.env.VUE_APP_API_DOMAIN + '/gh-app-server/extend-report-task/taskDetail',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/systemManagement.js